import { useContext } from 'react';
import { LangContext } from './LangProvider';
import type { Copy, Lang } from './index';

export function useLang(): {
  lang: Lang;
  t: Copy;
  setLang: (lang: Lang) => void;
} {
  const ctx = useContext(LangContext);
  if (!ctx) {
    throw new Error('useLang must be used inside a <LangProvider>.');
  }
  return ctx;
}

export function useT(): Copy {
  return useLang().t;
}
